import React from "react";
import { Box, Image } from "@chakra-ui/react";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import { Autoplay, Pagination, Navigation } from "swiper";
import { useState } from "react";
const sliderImg = [
  { img: "https://askmeguy.com/wp-content/uploads/2021/12/Fraazo-Rs-50-Off-Coupon.jpg.webp", id: 3763 },
  { img: "https://askmeguy.com/wp-content/uploads/2021/12/3-KG-Onion-Potato-Tomato-Combo-Offer-Coupon-Fraazo-1024x425.jpg", id: 3765 },
  { img: "https://askmeguy.com/wp-content/uploads/2021/12/Free-Masala-Offer-Fraazo-Coupon-1024x426.jpg", id: 3766 },
  // { img: "", id: 3767 },
  // { img: "", id: 3768 },
];
const ImageSlider = () => {
  const [images, setImages] = useState(sliderImg);

  return (
    <Box>
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={false}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
      >
        {images.map((item, index) => (
          <SwiperSlide key={item.id}>
            <Image src={item.img} height="auto" width="1000px" />
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};

export default ImageSlider;


